export const admimMenu = [
  {
    title: 'KYC',
    path: '/kyc/list',
    icon: 'fas fa-file-check',
    subMenuCollapse: true,
    submenu: []
  },
];



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/config/adminMenuConfig/admin.menu.ts